<template>
<div class="flex flex-col bg-white rounded-lg">
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="py-2 align-middle lg:px-8">
      <div class="overflow-y-auto border-gray-200 sm:rounded-lg rounded-lg scrollbar-w-2 scrollbar-track-gray-lighter scrollbar-thumb-rounded scrollbar-thumb-gray max-h-full">
        <table class="min-w-full divide-y divide-gray-200 table-collapse">
          <thead>
            <tr>
              <template v-for="header in headers">
                <th v-bind:key="header.id" class="z-5 sticky top-0 px-6 py-2 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase">
                  {{header.title}}
                </th>
              </template>
              <th v-for="action in actions" v-bind:key="action.header" class="z-5 sticky top-0 px-6 py-2 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase">
                {{action.header}}
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200 w-full">
            <tr v-for="row in rows" :key="row.id" @click="selectItem(row)" v-on:dblclick="$emit('item-dblclick', row)" class="hover:bg-gray-100 focus:outline-none focus:bg-gray-100" :class="selectedItem === row ? 'bg-gray-200' : ''">
              <template v-for="header in headers">
                <td v-if="header.renderer === 'datetime'" v-bind:key="header.key" class="px-6 py-2 whitespace-no-wrap text-xs leading-4 text-gray-700">
                  {{localize(row[header.key])}}
                </td>
                <td v-else-if="header.renderer === 'timedelta'" v-bind:key="header.key" class="px-6 py-2 whitespace-no-wrap text-xs leading-4 text-gray-700">
                  {{formatDelta(row[header.key])}}
                </td>
                <td v-else v-bind:key="header.key" class="px-6 py-2 whitespace-no-wrap text-xs leading-4 text-gray-700">
                  {{row[header.key]}}
                </td>
              </template>
              <td v-for="action in actions" v-bind:key="action.header" class="px-6 py-2 whitespace-no-wrap text-xs leading-4 text-gray-700">
                <button type="button" class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 text-xs leading-4 font-medium rounded text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150"
                  v-on:click.stop="action.method(row)">
                  {{action.text}}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { format, parseISO, intervalToDuration, addSeconds } from 'date-fns'
export default {
  name: "data-table",
  props: {
    rows: {
      type: Array,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    actions: { /* {header: String, text: String, method: function} */
      type: Array,
      required: false
    }
  },
  data() {
    return {
      selectedItem: {}
    }
  },
  watch: {
    headers(newValue) {
      console.log('headers', newValue)
    },
    rows(newValue) {
      console.log('rows', newValue)
    }
  },
  methods: {
    selectItem(item) {
      this.selectedItem = item
      this.$emit('select-item', JSON.parse(JSON.stringify(item)))
    },
    localize(item) {
      return format(parseISO(item + 'Z'), 'dd/MM/yy HH:mm:ss')
    },
    formatDelta(secs) {
      let duration = { days:0, hours:0, minutes:0, seconds:0 }
      if(secs){
        duration = intervalToDuration({
          start: new Date(),
          end: addSeconds(new Date(), secs)
        })
      }
      const zeros = data => data <= 9 ? `0${data}` : data

      if(duration.days == 1) {
        return `${duration.days} día, ${zeros(duration.hours)}:${zeros(duration.minutes)}:${zeros(duration.seconds)}`
      } else if(duration.days > 1){
        return `${duration.days} días, ${zeros(duration.hours)}:${zeros(duration.minutes)}:${zeros(duration.seconds)}`
      } else {
        return `${zeros(duration.hours)}:${zeros(duration.minutes)}:${zeros(duration.seconds)}`
      }
    },
  }
}
</script>
